import React from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';

/** variant 'default' = azul/ciano (bolha de texto), 'light' = branco (bolha de áudio/mídia froMe), 'muted' = card claro */
export const StatusIndicator: React.FC<{ status?: string; isMe: boolean; variant?: 'default' | 'light' | 'muted' }> = ({ status, isMe, variant = 'default' }) => {
    if (!isMe) return null;

    const checkColor =
        variant === 'light'
            ? 'text-white/60'
            : variant === 'muted'
              ? 'text-muted'
              : 'text-blue-200';

    const checkReadColor =
        variant === 'light'
            ? 'text-white/90'
            : variant === 'muted'
              ? 'text-primary'
              : 'text-cyan-200';

    return (
        <>
            {(status === 'pending' || status === 'uncertain') && (
                <span aria-label="Aguardando confirmação do envio" title="Aguardando confirmação do envio">
                    <AppIcon name="clock" className={`w-3 h-3 ${checkColor} flex-shrink-0`} />
                </span>
            )}
            {(!status || status === 'sent') && (
                <AppIcon name="check" className={`w-3 h-3 ${checkColor} flex-shrink-0`} />
            )}
            {status === 'delivered' && (
                <span className="flex -space-x-1.5 flex-shrink-0">
                    <AppIcon name="check" className={`w-3 h-3 ${checkColor}`} />
                    <AppIcon name="check" className={`w-3 h-3 ${checkColor}`} />
                </span>
            )}
            {status === 'read' && (
                <span className="flex -space-x-1.5 flex-shrink-0">
                    <AppIcon name="check" className={`w-3 h-3 ${checkReadColor}`} />
                    <AppIcon name="check" className={`w-3 h-3 ${checkReadColor}`} />
                </span>
            )}
            {status === 'failed' && (
                <AppIcon name="alert" className="w-3 h-3 text-red-300 flex-shrink-0" />
            )}
        </>
    );
};
